import type * as ContractTypes from '@draftkings/dk-data-layer';

export function getTeamsScore(
    event: ContractTypes.SportEvent,
    skipParseScoreboards: boolean
): { firstTeamScore: string; secondTeamScore: string } | undefined {
    if (skipParseScoreboards) {
        const firstTeamScore = event.eventScorecard?.mainScorecard?.firstTeamScore;
        const secondTeamScore = event.eventScorecard?.mainScorecard?.secondTeamScore;

        if (!firstTeamScore || !secondTeamScore) {
            return undefined;
        }

        return {
            firstTeamScore,
            secondTeamScore
        };
    }
    return undefined;
}
